// Uploads a file to Supabase Storage (public "media" bucket) and returns a
// public URL. Free tier, part of your own Supabase project — no extra service.
import { supabase, MEDIA_BUCKET } from "../supabase/client";

const slug = (name) => name.replace(/[^a-zA-Z0-9._-]/g, "_");

/**
 * @param {File} file
 * @param {string} [folder="reports"]  Sub-path inside the bucket.
 * @returns {Promise<{url: string, path: string}>}
 */
export async function uploadFile(file, folder = "reports") {
  // Unique-ish path; Date.now() is fine in app code (not a workflow script).
  const path = `${folder}/${Date.now()}-${slug(file.name)}`;

  const { error } = await supabase.storage
    .from(MEDIA_BUCKET)
    .upload(path, file, { cacheControl: "3600", upsert: false });
  if (error) throw error;

  const { data } = supabase.storage.from(MEDIA_BUCKET).getPublicUrl(path);
  return { url: data.publicUrl, path };
}
